import api from './api';
// 获得新闻列表
export function newsList(params) {
  return api.post('/en/news/getNewsList', params, true, false);
}
// 获得具体某条新闻
export function newsInfo(params) {
  return api.post('/en/news/getNews', params, true, false);
}

// 新闻上下条播报
export function forecastNews(params) {
  return api.post('/en/news/getNbs', params, true, false);
}



// WEBPACK FOOTER //
// ./src/api/enFrontApi/news.js